"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationRule = void 0;
var condition_rule_1 = require("./condition-rule");
var property_1 = require("./property");
var ValidationRule = /** @class */ (function (_super) {
    __extends(ValidationRule, _super);
    function ValidationRule(rootType, options) {
        var _this = this;
        // ensure the rule name is specified
        options.name = options.name || "ValidatedProperty";
        // store the property being validated
        var property = options.property;
        // ensure the properties and predicates to include the target property
        if (!options.properties)
            options.properties = [];
        if (!options.properties.includes(property))
            options.properties.push(property);
        if (!options.onChangeOf) {
            options.onChangeOf = [property];
        }
        else if (options.onChangeOf.indexOf(property) < 0) {
            options.onChangeOf.push(property);
        }
        // default condition category to Error if a condition category was not specified
        if (!options.conditionType) {
            options.category = "Error";
        }
        // replace the property label token in the validation message if present
        if (options.message && (typeof options.message === "function" || (typeof options.message === "string" && options.message.indexOf("{property}") >= 0))) {
            // Property label with dynamic format tokens
            if (property.labelIsFormat) {
                var labelSourceType_1 = property_1.getLabelSourceType(property);
                var labelFormat = property_1.getLabelFormat(property);
                // ensure tokens included in the format trigger rule execution
                labelFormat.paths.forEach(function (p) {
                    labelSourceType_1.getPaths(p).forEach(function (prop) {
                        var labelTokenProp = prop;
                        if (property.labelSource) {
                            labelTokenProp = rootType.getPath(property.labelSource.path + "." + prop.path);
                        }
                        if (!options.onChangeOf) {
                            options.onChangeOf = [labelTokenProp];
                        }
                        else if (options.onChangeOf.indexOf(labelTokenProp) < 0) {
                            options.onChangeOf.push(labelTokenProp);
                        }
                    });
                });
                if (typeof options.message === "function") {
                    var messageFunction_1 = options.message;
                    // Create a function to apply the format to the property label when generating the message
                    options.message = function () {
                        var message = "";
                        try {
                            message = messageFunction_1.call(this);
                            if (typeof message === "string") {
                                if (message.trim().length > 0 && message.indexOf("{property}") >= 0) {
                                    message = message.replace("{property}", property_1.evaluateLabel(property, this));
                                }
                            }
                            else if (message != null) {
                                console.warn("Converting message of type '" + (typeof message) + "' for rule '" + options.name + "' to a string.");
                                message = message.toString();
                            }
                        }
                        catch (e) {
                            console.warn(e);
                        }
                        return message;
                    };
                }
                else if (typeof options.message === "string") {
                    var messageTemplate_1 = options.message;
                    // Create a function to apply the format to the property label when generating the message
                    options.message = function () {
                        return messageTemplate_1.replace("{property}", property_1.evaluateLabel(property, this));
                    };
                }
            }
            // Static property label
            else if (typeof options.message === "string") {
                options.message = options.message.replace("{property}", property.label);
            }
            // Use static property label in function return value
            else if (typeof options.message === "function") {
                var messageFunction_2 = options.message;
                // Create a function to apply the format to the property label when generating the message
                options.message = function () {
                    var message = "";
                    try {
                        message = messageFunction_2.call(this);
                        if (typeof message === "string") {
                            if (message.trim().length > 0 && message.indexOf("{property}") >= 0) {
                                message = message.replace("{property}", property.label);
                            }
                        }
                        else if (message != null) {
                            console.warn("Converting message of type '" + (typeof message) + "' for rule '" + options.name + "' to a string.");
                            message = message.toString();
                        }
                    }
                    catch (e) {
                        console.warn(e);
                    }
                    return message;
                };
            }
        }
        if (options.isValid) {
            options.assert = function () {
                var isValid;
                try {
                    isValid = options.isValid.call(this, options.property, options.property.value(this));
                }
                catch (e) {
                    console.warn(e);
                }
                return isValid === undefined ? isValid : !isValid;
            };
        }
        // call the base rule constructor
        _this = _super.call(this, rootType, options) || this;
        Object.defineProperty(_this, "property", { value: property });
        // register the rule with the target property
        _this.property.rules.push(_this);
        return _this;
    }
    return ValidationRule;
}(condition_rule_1.ConditionRule));
exports.ValidationRule = ValidationRule;
